<template>
  <div class="gfq-wrap">
    <div class="gfq-panel">
      <div class="gfq-panel-header d-flex flex-column align-items-center">
        <img src="/img/logo_abtool.svg" width="215" height="auto">
        <p style="font-size: 15px" class="mb-0 text-center">
          <b>Come possiamo aiutarti?</b>
        </p>
        <p style="margin: 0; font-size: 13px; opacity: 0.6">Scrivici e ti risponderemo al più presto</p>
      </div>

      <div class="gfq-panel-body">
        <form @submit.prevent="sendData">
          <div class="form-group">
            <input type="text" id="subject" placeholder="Oggetto" name="subject" v-model="formData.subject" class="form-control">
          </div>
          <div class="form-group">
            <textarea rows="6" id="msg" placeholder="Come possiamo aiutari? Spiegaci tutto nei dettagli e faremo il possibile per aiutarti"
                      name="subject" v-model="formData.msg" class="form-control"></textarea>
          </div>

          <button type="submit" class="w-100 btn btn-success abtg__btn-third shadow-none abtg-button-big">
            Invia la tua richiesta<i class="fas fa-sync-alt fa-spin ml-3" v-if="isLoading"></i>
          </button>
        </form>

        <div class="alert alert-success" v-if="successMsg">
          Grazie per averci contattato!<br>
          Riceverai presto una nostra risposta.
        </div>
      </div>
    </div>
    <div class="gfq-badge" @click="goToLink">
      <img src="/img/email.svg" class="gfq-email-icon" width="70px"
           alt="Icon"/>
      <span class="gfq-close-icon">
            <i class="fas fa-times text-white"></i>
        </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "floatingForm",
  data() {
    return {
      formData: {},
      successMsg: false,
      isLoading: false
    }
  },
  methods: {

    goToLink()
    {
      // axios.defaults.headers.common['Authorization'] = 'Bearer 1|DbL4iOtZqK0UOyPFrsvMhaQs6lsvNbPOhL7I5SRi';
      //axios.defaults.withCredentials = false;
     // axios.defaults.headers.post['Accept'] = 'application/json';

      // axios('https://ticket.universecrm.it/api/slug/fralette@gmail.com/email', {
      //   method: 'GET',
      //   mode: 'no-cors',
      //   headers: {
      //     'Access-Control-Allow-Origin': '*',
      //     'Content-Type': 'application/x-www-form-urlencoded'
      //   },
      //   withCredentials: false,
      //   credentials: 'same-origin',
      // }).then(response => {
      // })



      window.open('https://ticket.universecrm.it/demo','_blank');
    },

    triggerBadge() {
      let condition = $('.gfq-panel').hasClass('panel-active');

      setTimeout(() => {
        $('.gfq-panel').toggleClass('d-block');
      }, condition ? 320 : 0);

      setTimeout(() => {
        $('.gfq-panel').toggleClass('panel-active');

        let emailIcon = $('.gfq-badge').find('.gfq-email-icon');
        let closeIcon = $('.gfq-badge').find('.gfq-close-icon');

        emailIcon.toggle(300);
        closeIcon.toggle(300);
        setTimeout(() => {
          closeIcon.toggleClass('d-flex');
          this.successMsg = false;
        }, 150)
      }, condition ? 0 : 50)
    },

    sendData() {
      this.isLoading = true;

      axios.post('/api/v1/contact/sendEmail', this.formData)
        .then(() => {
          this.successMsg = true;
          this.isLoading = false;
          this.formData = {};
        })
    }
  }
}
</script>

<style scoped>

</style>
